module.exports = __webpack_public_path__ + "media/images/pago-d908836eee0e67997a28950502ea2b08.svg";